module.exports = __webpack_public_path__ + "h5/img/sh.29aa8b0b.png";